module.exports = __webpack_public_path__ + "img/customer_tag_3.a7a381b9.png";